define("shared/components/shared/ui/search-box/results", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class={{concat "tSC--drop " @additionalClasses}} ...attributes>
    <div class="tSC--dropBody">
      <ul class="tSC--dropBody__list">
        {{#each @searchResults as |result|}}
          <Shared::Ui::SearchBox::Result
            @onSelectAction={{action @onSelectAction}}
            @result={{result}}
            class="qa--categorize_search_box_result_item"
          />
        {{else}}
          <Shared::Ui::SearchBox::ResultBlank
            @message={{t "profile_categorization.search.no_results_found"}}
            class="qa--categorize_search_box_result_blank_item"
          />
        {{/each}}
      </ul>
    </div>
  </div>
  */
  {
    "id": "/C2xTrHY",
    "block": "[[[11,0],[16,0,[28,[37,0],[\"tSC--drop \",[30,1]],null]],[17,2],[12],[1,\"\\n  \"],[10,0],[14,0,\"tSC--dropBody\"],[12],[1,\"\\n    \"],[10,\"ul\"],[14,0,\"tSC--dropBody__list\"],[12],[1,\"\\n\"],[42,[28,[37,2],[[28,[37,2],[[30,3]],null]],null],null,[[[1,\"        \"],[8,[39,3],[[24,0,\"qa--categorize_search_box_result_item\"]],[[\"@onSelectAction\",\"@result\"],[[28,[37,4],[[30,0],[30,5]],null],[30,4]]],null],[1,\"\\n\"]],[4]],[[[1,\"        \"],[8,[39,5],[[24,0,\"qa--categorize_search_box_result_blank_item\"]],[[\"@message\"],[[28,[37,6],[\"profile_categorization.search.no_results_found\"],null]]],null],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@additionalClasses\",\"&attrs\",\"@searchResults\",\"result\",\"@onSelectAction\"],false,[\"concat\",\"each\",\"-track-array\",\"shared/ui/search-box/result\",\"action\",\"shared/ui/search-box/result-blank\",\"t\"]]",
    "moduleName": "shared/components/shared/ui/search-box/results.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});